export const GHG_CONTEXT = 'GHG';
export const GHG_GOOGLE_ANALYTICS_TAG = 'GHG';
